import { css } from '@emotion/core';
import { variables as vars } from '@domain-group/fe-brary';
var colour = vars.colour,
  font = vars.font;
export default _ref => {
  var _ref$inactiveColour = _ref.inactiveColour,
    inactiveColour = _ref$inactiveColour === void 0 ? colour.neutral600 : _ref$inactiveColour,
    _ref$activeColour = _ref.activeColour,
    activeColour = _ref$activeColour === void 0 ? colour.brandYellow : _ref$activeColour,
    isLoading = _ref.isLoading;
  var button = /*#__PURE__*/css("background:none;margin:5px 0 0;padding:0;border:0;outline:none;", !isLoading && 'cursor: pointer;', " font-weight:", font.headingFontWeight, ";stroke-width:2px;color:", inactiveColour, ";&:hover{color:", activeColour, ";}");
  var spinner = /*#__PURE__*/css("width:24px;height:24px;padding-top:2px;span{border-top-color:", activeColour, ";}");
  var text = /*#__PURE__*/css("font-family:", font.bodyFontFamily, ";font-size:", font.smallFontSize, ";display:inline-block;vertical-align:top;margin:2px 5px 0 0;");
  var inWatchlist = /*#__PURE__*/css("color:", activeColour, ";");
  return {
    button,
    text,
    inWatchlist,
    spinner
  };
};